/**
 * @generated SignedSource<<2226fc27774a703d59fdc5d84f51a9be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InvoiceStatus = "applied" | "unapplied" | "unset";
export type UpdateInfluencerInfoMutationInput = {
  birthday?: string | null;
  clientMutationId?: string | null;
  commonName?: string | null;
  gender?: string | null;
  invoiceNo?: string | null;
  invoiceStatus?: InvoiceStatus | null;
  profile?: string | null;
  tiktokUrl?: string | null;
  twitterUrl?: string | null;
  ytChannel?: string | null;
};
export type InvoiceEditMutation$variables = {
  input: UpdateInfluencerInfoMutationInput;
};
export type InvoiceEditMutation$data = {
  readonly updateInfluencerInfo: {
    readonly __typename: "Influencer";
    readonly profile: {
      readonly invoiceNo: string | null;
      readonly invoiceStatus: InvoiceStatus;
    };
  } | {
    readonly __typename: "UpdateInfluencerInfoError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type InvoiceEditMutation = {
  response: InvoiceEditMutation$data;
  variables: InvoiceEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceStatus",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNo",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UpdateInfluencerInfoError",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvoiceEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvoiceEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61e085b7674da5eec9d612651beb37a2",
    "id": null,
    "metadata": {},
    "name": "InvoiceEditMutation",
    "operationKind": "mutation",
    "text": "mutation InvoiceEditMutation(\n  $input: UpdateInfluencerInfoMutationInput!\n) {\n  updateInfluencerInfo(input: $input) {\n    __typename\n    ... on Influencer {\n      profile {\n        invoiceStatus\n        invoiceNo\n        id\n      }\n      id\n    }\n    ... on UpdateInfluencerInfoError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b290e2e4fd060bcf8e12eee2602a3750";

export default node;
